function ErrorFallback() {
  return 'Error';
}

export default ErrorFallback;
